'use client';

import { useEffect, type FC } from 'react';
import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';

import { languageAlternatesAtom } from '@packages/modules/src/Header/MetaNavigation/shared/useLocaleSwitch.atom';
import { usePRankOptinTracking } from '@packages/search/src/hooks/usePRankTracking';

export const CategoryPageEffects: FC<{
  alternateLinks?: Record<string, string>;
}> = ({ alternateLinks }) => {
  const pathname = usePathname();
  const setLanguageAlternates = useSetAtom(languageAlternatesAtom);

  useEffect(() => {
    setLanguageAlternates({
      currentPathname: pathname ?? 'unknown',
      alternateLinks,
    });
  }, [alternateLinks, pathname, setLanguageAlternates]);

  // pRank A/B test: Send OPTIN: 1 once per category page entry
  usePRankOptinTracking();

  return null;
};
